export const defaultStyle = {
  navLink: `navLink font-MDLZBiteType text-[16px] md:leading-[100%] font-normal text-gray`,
  navContainer: "navContainer relative md:flex justify-center navUl md:gap-[16px] lg:gap-[26px] items-center",
}

export const ENG_HEADER_NEW = {
  ...defaultStyle,
}